// reservaUtils.js
// Utilidades compartidas para cálculo de precio y fechas de reserva

export function calculaDias({ fechaI, fechaF, periodo }) {
    if (!fechaI || !fechaF) return 0;
    let intervalo = Math.ceil((fechaF.getTime() - fechaI.getTime()) / 86400000) + 1;
    if (periodo === "2") {
        intervalo = Math.round(intervalo * 100 / 7) / 100;
    } else if (periodo === "3") {
        intervalo = Math.round(intervalo * 100 / 30) / 100;
    } else if (periodo === "4") {
        let aux = new Date(fechaI.getTime());
        intervalo = 0;
        while (fechaF >= aux) {
            intervalo++;
            aux.setFullYear(aux.getFullYear() + 1);
        }
        const diferenciaDias = Math.ceil((fechaF.getTime() - aux) / 86400000) + 1;
        intervalo += diferenciaDias / (fechaF.getFullYear() % 4 === 0 ? 366 : 365);
    }
    return intervalo;
}

export function calculaPrecio({ dias, periodo, typeTime }) {
    const precio = typeTime?.[periodo]?.price || 0;
    return dias * precio;
}

export function calculaFechaF({ fechaI, dias, periodo }) {
    if (!fechaI || !dias) return null;
    const aux = new Date(fechaI.getTime());
    if (periodo === "1") aux.setDate(aux.getDate() + dias - 1);
    else if (periodo === "2") aux.setDate(aux.getDate() + dias * 7 - 1);
    else if (periodo === "3") aux.setDate(aux.getDate() + dias * 30 - 1);
    else if (periodo === "4") {
        aux.setFullYear(aux.getFullYear() + dias);
        aux.setDate(aux.getDate() - 1);
    }
    return aux;
}
